import { render, staticRenderFns } from "./EditorCommentsView.vue?vue&type=template&id=4b323290&scoped=true&"
import script from "./EditorCommentsView.vue?vue&type=script&lang=js&"
export * from "./EditorCommentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b323290",
  null
  
)

export default component.exports